/**
 * Mirrors packages/amgfishprawncrab_v2/lib/presentation/rive/rive_inputs.dart
 */

export const FpcStateMachine = 'animationManager';

export const FpcInputs = {
  stateMachine: 'animationManager',

  // Top bowl (dice reveal) — on topBowlAnimation artboard.
  diceNum1: 'DiceNum1',
  diceNum2: 'DiceNum2',
  diceNum3: 'DiceNum3',
  diceBowlPlay: 'DiceBowlPlay',     // trigger
  diceBowlPosition: 'DiceBowlPosition', // number: 1=shaking, 2=revealed

  // Girl animation (on main artboard).
  girlAnimTrigger: 'GirlAnimplay',  // trigger
  girlAnimSelection: 'GirlAnimSeltion', // number: 1=idle, 2=end-of-round

  // Betting UI (on bettingui Main artboard).
  isMobile: 'isMobile',             // boolean

  // History: nested input `result` at path `Historyicon{1..10}`.
  nestedHistoryResult: 'result',
  historyPathPrefix: 'Historyicon',

  // Text runs (on main artboard).
  txtMinValue: 'txtMinValue',
  txtMaxValue: 'txtMaxValue',
} as const;

/** Names of Rive events the .riv emits — for documentation. */
export const RiveEventNames = {
  placeBetClick: 'placeBetClick',       // properties: { betID }
  evtClickChips: 'evtClickChips',       // properties: { chipsAmt } (1..6)
  evtClearClick: 'evtClearClick',
  evtButtonPlayClick: 'evtButtonPlayClick',
  evtSoundOnOff: 'evtSoundOnOff',
  evtMusicOnOff: 'evtMusicOnOff',
  UIButtonClick: 'UIButtonClick',       // properties: { parts: 'startEnd' | 'OutEnd' | 'noMoreBet_End' }
  DiceBowlEnd: 'DiceBowlEnd',           // properties: { parts: 'startEnd' | 'OutEnd' }
} as const;
